/** Мин./макс. видимые строки поля промпта */
export const PROMPT_MIN_ROWS = 2;
export const PROMPT_MIN_ROWS_MOBILE = 1;
export const PROMPT_MAX_ROWS = 12;
export const PROMPT_MOBILE_MAX_WIDTH = 768;

export function isPromptMobileViewport() {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(`(max-width: ${PROMPT_MOBILE_MAX_WIDTH}px)`).matches;
}

export function getPromptMinRows() {
    return isPromptMobileViewport() ? PROMPT_MIN_ROWS_MOBILE : PROMPT_MIN_ROWS;
}

function readLineMetrics(el) {
    const style = window.getComputedStyle(el);
    let lineHeight = parseFloat(style.lineHeight);
    if (!Number.isFinite(lineHeight) || lineHeight <= 0) {
        const fontSize = parseFloat(style.fontSize) || 15;
        lineHeight = fontSize * 1.45;
    }
    const padding =
        (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0);
    return { lineHeight, padding };
}

/**
 * Подгоняет высоту textarea: от minRows до maxRows, затем появляется scroll.
 * Пустое поле всегда ровно minRows (на мобильном — 1 строка), без раздувания scrollHeight.
 */
export function autoSizePromptTextarea(
    el,
    { minRows = getPromptMinRows(), maxRows = PROMPT_MAX_ROWS } = {}
) {
    if (!el) return;

    el.rows = minRows;
    const { lineHeight, padding } = readLineMetrics(el);
    const minH = Math.ceil(lineHeight * minRows + padding);
    const maxH = Math.ceil(lineHeight * maxRows + padding);

    // Пустой промпт: не опираемся на scrollHeight — браузер часто отдаёт 2–3 строки
    if (!el.value) {
        el.style.height = `${minH}px`;
        el.style.overflowY = 'hidden';
        return;
    }

    // Сначала схлопываем до минимума, потом меряем контент
    el.style.height = `${minH}px`;
    el.style.overflowY = 'hidden';
    const contentH = el.scrollHeight;
    const next = Math.min(Math.max(contentH, minH), maxH);
    el.style.height = `${next}px`;
    el.style.overflowY = contentH > maxH + 1 ? 'auto' : 'hidden';
}
